import { render, staticRenderFns } from "./wenjuan.vue?vue&type=template&id=2ddf6d9c&scoped=true&"
import script from "./wenjuan.vue?vue&type=script&lang=ts&"
export * from "./wenjuan.vue?vue&type=script&lang=ts&"
import style0 from "./wenjuan.vue?vue&type=style&index=0&id=2ddf6d9c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ddf6d9c",
  null
  
)

export default component.exports